"use client";

import AnalystWorkflowStage from "../../how-it-works/AnalystWorkflowStage";

export default function MethodSection() {
  return (
    <section id="method" className="pt-14 pb-2 md:pt-20 md:pb-3 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none z-10" style={{ background: "linear-gradient(to top, #0E0E0E, transparent)" }} />
      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-20">
        <div>
          <div className="text-center mb-5 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#DCE2EC]/70">
            The Method
          </div>

          <h2 className="text-3xl sm:text-4xl font-semibold text-center mb-4 leading-tight text-white">
            How Bastion Turns Noise Into Signal
          </h2>
          <p className="text-lg text-white/55 text-center mb-4 max-w-2xl mx-auto">
            Score the metrics that matter, then combine them into a single score. The best fit for your goal rises to the top.
          </p>
        </div>

        <div style={{ marginTop: "-28px" }}>
          <AnalystWorkflowStage />
        </div>
      </div>
    </section>
  );
}
